// src/utils/tesisat/coordinateHelpers.js
//
// Tesisat koordinat donusum yardimcilari ve sabitler.

// floorPlanSlice legacy key'ler kullanir ('elektrik'), scenesRef resolved
// key kullanabilir ('strong_current'). Bu map ile legacy'ye ceviriyoruz.
export const RESOLVED_TO_LEGACY = {
  strong_current: 'elektrik',
  weak_current: 'telekom',
  fire_detection: 'yangin',
  construction_site: 'santiye',
  connection_line: 'baglanti',
};

// Eski dosyalarda (_v yok) tum tesisat tiplerinin position'i LOCAL kaydedilmis.
export const LOCAL_BUG_TYPES = [
  'socket', 'mainPanel', 'electricalPanel', 'supplyPoint',
  'machine', 'LightSwitch', 'LightFixture',
];

/**
 * Dual coordinate frame detection:
 * Panel/socket/supply: fpMesh-LOCAL (Y positive, 0..meshHeight araliginda)
 * Machine/LightSwitch/LightFixture: documentGroup-LOCAL (Y negative)
 * Bounds check ile hangisi oldugunu tespit edip fpMesh-LOCAL'e cevirir.
 */
export function toFpMeshLocal(pos, fpMesh) {
  const px = pos.x ?? 0;
  const py = pos.y ?? 0;
  const meshH = fpMesh.userData.meshHeight || 0;
  const isFpMeshLocal = py >= -50 && py <= meshH + 50;
  if (isFpMeshLocal) {
    return { x: px, y: py, z: 0 };
  }
  return {
    x: px - fpMesh.position.x,
    y: py - fpMesh.position.y,
    z: 0,
  };
}
